import { BlueText, Container, InsertText } from './style';

export interface TextContainerI {
  text: string;
  callback?: (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
}

const TextContainer = ({ text, callback }: TextContainerI): JSX.Element => {
  return (
    <Container>
      <InsertText>{text}</InsertText>
      {callback && (
        <BlueText
          onClick={(e) => {
            callback(e);
          }}
        >
          Try again
        </BlueText>
      )}
    </Container>
  );
};

export default TextContainer;
